<template lang="pug">
  v-container
    PurchaseDetail
</template>

<script>
// @ is an alias to /src
import PurchaseDetail from '../components/PurchaseDetail/PurchaseDetail'
export default {
  name: 'Home',
  components: {
    PurchaseDetail
  }
}
</script>
